// ACTION TYPES
export const Types = {
  TRIGGER: 'FILTERS/TRIGGER',
  REQUEST: 'FILTERS/REQUEST',
  ERROR: 'FILTERS/ERROR',
  SUCCESS: 'FILTERS/SUCCESS',
  FULFILL: 'FILTERS/FULFILL',
  TRIGGER_FILTER: 'FILTERS/TRIGGER_FILTER',
};

// INITIAL STATE
const initialState = {
  currentFilter: 0,
  currentFilterName: '',
};

// REDUCER
export default (state = initialState, action) => {
  switch (action.type) {
    case Types.REQUEST:
      return {
        ...state,
        loading: true,
      };
    case Types.ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case Types.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case Types.FULFILL:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

// ACTIONS
export const trigger = () => {
  return {
    type: Types.TRIGGER,
  };
};

export const triggerFilter = (codename) => {
  return {
    type: Types.TRIGGER_FILTER,
    payload: codename,
  };
};

export const request = () => {
  return {
    type: Types.REQUEST,
  };
};

export const fulfill = () => {
  return {
    type: Types.FULFILL,
  };
};

export const failed = (error) => {
  return {
    type: Types.ERROR,
    payload: error,
  };
};

export const success = (payload) => {
  return {
    type: Types.SUCCESS,
    payload,
  };
};
